//
//
//
//
//
//
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      default: ''
    }
  },
  methods: {
    handleChange: function handleChange(e) {
      this.$emit('change', e);
    }
  }
};